

import React from 'react';
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";

import css from './SampleMenuPacksSingleComponent.module.css';
import {sampleMenuActions} from "../../../store/slices/menu-slices";
import {SingleMenuDishComponent} from "../SingleMenuDishComponent/SingleMenuDishComponent";


const SampleMenuPacksSingleComponent = ({pack, setIsOpen}) => {
    const dispatch = useDispatch();
    const {id, name, meals, sampleMenuDishes} = pack;

    const {i18n} = useTranslation();
    const currentLanguage = i18n.language;
    const displayName = name[currentLanguage] || name['en'];

    const openModal = (mealId) => {
        const matchingDish = sampleMenuDishes.find((item) => item.mealId === mealId);
        const idMatching = matchingDish ? matchingDish.id : null;

        setIsOpen(true);
        dispatch(sampleMenuActions.changeId(id));
        dispatch(sampleMenuActions.changeIdForMeal(mealId));
        dispatch(sampleMenuActions.changeIdMatching(idMatching || ''));
    };


    return (
        <div className={css.wrap}>
            <div className={css.header}>{displayName}</div>

            {meals && meals.map((meal) => {
                const mealName = meal.name[currentLanguage] || meal.name['en'];
                const matchingDish = sampleMenuDishes.find((item) => item.mealId === meal.id);

                return (
                    <div
                        className={css.container}
                        key={`${id}-${meal.id}`}
                        onClick={() => openModal(meal.id)}
                    >
                        <div className={css.info}>
                            {matchingDish ? (
                                <SingleMenuDishComponent dish={matchingDish.dish} />
                            ) : (
                                <div className={css.noData}>No data</div>
                            )}
                        </div>

                        <div className={css.meal}>{mealName}</div>
                    </div>
                );
            })}
        </div>
    );
};

export default React.memo(SampleMenuPacksSingleComponent);

